// Conversion signals for the Google tag (GTM-549SR39): pushes an event to the dataLayer.
// Google stores cookies only if the visitor accepted statistics (Consent Mode, see public/index.html).
// No personal data (name, email, phone) is ever sent.
export const track = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

// Contact clicks (phone, WhatsApp, email) anywhere on the site: one listener on the document.
// WhatsApp "share" links (wa.me/?text=) have no number and are not counted as contacts.
const METHOD = [[/^tel:/i, "telefono"], [/^mailto:/i, "email"], [/^https?:\/\/(wa\.me|api\.whatsapp\.com)\/\d/i, "whatsapp"]];
export const trackContactClicks = () => {
  const onClick = (e) => {
    const a = e.target.closest?.("a[href]");
    const method = a && METHOD.find(([re]) => re.test(a.getAttribute("href")))?.[1];
    if (!method) return;
    track("contact_click", { metodo: method, posizione: a.dataset.testid ?? a.closest("[data-testid]")?.dataset.testid ?? "", pagina: window.location.pathname });
  };
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
};
